module.exports = __webpack_public_path__ + "img/gateway-gray.da8ed80b.png";